import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { IoMdColorFill } from "react-icons/io";
import { FiDelete } from "react-icons/fi";
import SimpleColorPicker from "components/ColorPicker";

const ShiftColorField = ({
	controlId,
	label,
	value,
	placeholder = "#FFFFFF",
	isInvalid = false,
	error = "",
	onClear,
	onTogglePicker,
	isPickerVisible,
	onColorChange,
	onClosePicker,
	colors = [],
}) => {
	const fieldRef = useRef(null);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const updatePickerPosition = () => {
		const fieldEl = fieldRef.current;
		if (!fieldEl) return;
		const rect = fieldEl.getBoundingClientRect();
		setPickerPosition({
			top: rect.bottom + 6,
			left: rect.left,
		});
	};

	useEffect(() => {
		if (!isPickerVisible) return undefined;

		updatePickerPosition();
		const onScroll = () => updatePickerPosition();
		const onResize = () => updatePickerPosition();

		window.addEventListener("scroll", onScroll, true);
		window.addEventListener("resize", onResize);

		return () => {
			window.removeEventListener("scroll", onScroll, true);
			window.removeEventListener("resize", onResize);
		};
	}, [isPickerVisible]);

	const pickerPortal =
		isPickerVisible && typeof document !== "undefined"
			? createPortal(
					<div
						className="shift-color-field__picker-portal"
						style={{
							position: "fixed",
							top: pickerPosition.top,
							left: pickerPosition.left,
							zIndex: 2200,
						}}
					>
						<SimpleColorPicker
							color={value ? value : "#ffffff"}
							colors={colors}
							onChange={onColorChange}
							onClose={onClosePicker}
						/>
					</div>,
					document.body
			  )
			: null;

	return (
		<>
			<FormGroup
				ref={fieldRef}
				className="form-group form-color form-color-preview shift-color-field"
				controlId={controlId}
				style={{
					"--preview-color": value || "transparent",
				}}
			>
				<div className="flex-between">
					<FormLabel>{label}</FormLabel>
					<FiDelete
						className={`icon-remove-color ${!value ? "hidden" : ""}`}
						onClick={onClear}
					/>
				</div>

				<FormControl
					type="text"
					className="color-preview-input"
					value={value}
					placeholder={placeholder}
					readOnly
					isInvalid={isInvalid}
					onClick={onTogglePicker}
				/>
				<FormControl.Feedback type="invalid">{error}</FormControl.Feedback>

				<IoMdColorFill onClick={onTogglePicker} />
			</FormGroup>
			{pickerPortal}
		</>
	);
};

export default ShiftColorField;
